import { useTranslations } from 'next-intl';
import BidHistoryListItem from './BidHistoryListItem';
import { useState } from 'react';
import { countUniqueBidders } from '@/src/utils/countUniqueBidders';
import useShowPrice from '@/src/utils/useShowPrice';

export default function BidHistoryList({ auction }: { auction: any }) {
  const t = useTranslations('BidHistory');
  const [maxNumberOfHistoryItems, setMaxNumberOfHistoryItems] = useState(5);
  const showPrice = useShowPrice(auction);
  const totalHistoryItems = auction?.bids?.length;
  const uniqueBiddersCount = countUniqueBidders(
    auction?.bids ? auction.bids : []
  );

  return (
    <section className='px-6 mt-6'>
      <div className='flex border-b border-black flex-wrap items-center justify-between'>
        <h3 className='font-semibold'>{t('title')}</h3>
        <span className='text-sm font-semibold'>
          {t('biddersCount')}: {uniqueBiddersCount}
        </span>
      </div>
      {!!totalHistoryItems && (
        <table className='mt-2 w-full text-sm'>
          {[...auction.bids].map(
            (bid: any, i: number) =>
              i <= maxNumberOfHistoryItems && (
                <BidHistoryListItem key={i} bid={bid} winning={i < 1} showPrice={showPrice} />
              )
          )}
        </table>
      )}
      {totalHistoryItems > maxNumberOfHistoryItems && (
        <button
          className='w-full text-center text-sm font-semibold underline'
          onClick={() => setMaxNumberOfHistoryItems(totalHistoryItems)}
        >
          {t('showMore')}
        </button>
      )}
    </section>
  );
}
